import { useFormContext } from 'react-hook-form';
import { DateRangeTimezoneValue } from 'shared/mui/DatePicker/DateTimeRangeTimezonePicker/DateTimeRangeTimezonePicker';

type UseFilterTimezoneResult = {
  timezone: DateRangeTimezoneValue;
  onChangeTimezone: (timezone: DateRangeTimezoneValue) => void;
};

/**
 * Общая таймзона фильтра: все пикеры дат на странице читают и пишут одно поле формы.
 */
export function useFilterTimezone(name = 'timezone'): UseFilterTimezoneResult {
  const { watch, setValue } = useFormContext();

  return {
    timezone: watch(name),
    onChangeTimezone: (timezone: DateRangeTimezoneValue) => setValue(name, timezone),
  };
}
